import React, { useEffect, useRef } from "react";
import Image from "next/image";
import Autoplay from "embla-carousel-autoplay";
import useEmblaCarousel from "embla-carousel-react";
import GlobalForm from "@/components/forms/GlobalForm";
import {
  FinanceAndAccountingSubcategory,
  FormHeading,
  SuccessMessageType,
  VerticalCategory,
} from "@/interface/types";

const LpUspBanner = () => {
  const autoplayRef = useRef(
    Autoplay({
      delay: 2000,
      stopOnInteraction: false,
      stopOnMouseEnter: true,
      stopOnFocusIn: false,
    }),
  );

  const [emblaRef, emblaApi] = useEmblaCarousel(
    {
      loop: true,
      align: "start",
      slidesToScroll: 1,
      skipSnaps: false,
      breakpoints: {
        "(min-width: 768px)": { slidesToScroll: 1 },
        "(min-width: 1024px)": { slidesToScroll: 1 },
      },
    },
    [autoplayRef.current],
  );

  useEffect(() => {
    if (emblaApi && autoplayRef.current) {
      autoplayRef.current.play();
    }
  }, [emblaApi]);

  return (
    <>
      <div className="md:block -mt-2 hidden mx-auto w-full 2xl:h-[700px] md:h-[627px] h-[95vh] xl:px-0 md:px-6 lg:!px-6  px-5 relative md:bg-bottom bg-center square_grid_bg bg-repeat bg-[length:100% 100%] md:pb-0 pb-[0px]">
        <div className="lg:container h-full mx-auto 2xl:px-0 xl:px-10 lg:p-0 text-[#030F1C] z-50 relative">
          <div className="flex justify-between items-center relative md:top-[80px] mx-auto">
            <div className="md:relative w-full md:mt-5 mt-7">
              <Image
                src="/usp/lp-usp.png"
                alt="Special Offer"
                className="block w-[57%] ml-[-16px]"
                width={471}
                height={155}
                priority
              />

              <p className="2xl:text-[28px] md:text-[24px] text-[20px] font-medium  leading-[116%] tracking-[-0.96px] text-[#202852] mt-6">
                Miles has cracked the puzzle for
                <br /> Indian Accountants to
              </p>
              <h1 className="2xl:text-[60px] md:text-[56px] text-[34px] font-bold leading-normal tracking-[-2.24px] text-[#061a2f] md:text-[#061A2F] mt-[-6px]">
                Work in the US
              </h1>
              <p className="text-[#000] font-semibold lg:text-[20px] md:text-[20px] text-[24px] mt-[-2px] leading-normal tracking-[-0.8px]">
                Starting salary{" "}
                <span className="bg-[#FFBA08] font-semibold lg:text-[20px] md:text-[20px] text-[24px]  leading-normal tracking-[-0.8px]">
                  $60,000+ (₹50 lakhs+)
                </span>
              </p>
              <div className="md:block hidden w-full mt-3 z-30">
                <div className="lg:container">
                  <div className="flex md:justify-between ml-[-18px] md:flex-nowrap flex-wrap md:px-4 pt-1 pb-1 border border-[#3399FF33] bg-white w-[338px] rounded-[8px]">
                    <div className="text-center">
                      <p className="text-[18px] font-semibold leading-normal tracking-[-0.72px] text-[#202852]">
                        70,000+
                      </p>
                      <p className="text-[12px] leading-normal tracking-[-0.48px] font-medium text-[#202852] mt-1">
                        Global Alumni
                      </p>
                    </div>
                    <div className="grey_divider"></div>
                    <div className="text-center md:mt-0 mt-5">
                      <p className="text-[18px] font-semibold leading-normal tracking-[-0.72px] text-[#202852]">
                        600+
                      </p>
                      <p className="text-[12px] leading-normal tracking-[-0.48px] font-medium text-[#202852] mt-1">
                        Employers
                      </p>
                    </div>
                    <div className="grey_divider"></div>
                    <div className="text-center md:mt-0 mt-5">
                      <p className="text-[18px] font-semibold leading-normal tracking-[-0.72px] text-[#202852]">
                        100+
                      </p>
                      <p className="text-[12px] leading-normal tracking-[-0.48px] font-medium text-[#202852] mt-1">
                        Universities
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <p className="italic font-semibold text-[#272727] md:text-[16px] md:mt-[26px] leading-normal tracking-[-0.96px]">
                Our alumni work at
              </p>
              <div className="md:w-full md:mt-5">
                <div
                  className=" w-full pb-4 embla overflow-hidden"
                  ref={emblaRef}
                >
                  <div className="embla__container flex h-full">
                    <div className="embla__slide h-full flex-[0_0_70%] min-w-0 sm:flex-[0_0_50%] md:flex-[0_0_33%] lg:flex-[0_0_23.67%] pr-7">
                      <Image
                        src="/cpa/usp/us_logo1.png"
                        alt="MBE"
                        className=" mx-auto"
                        width={75}
                        height={45}
                      />
                    </div>
                    <div className="embla__slide h-full flex-[0_0_70%] min-w-0 sm:flex-[0_0_50%] md:flex-[0_0_33%] lg:flex-[0_0_23.67%] pr-7">
                      <Image
                        src="/cpa/usp/us_logo2.png"
                        alt="MBE"
                        className=""
                        width={105}
                        height={40}
                      />
                    </div>
                    <div className="embla__slide h-full flex-[0_0_70%] min-w-0 sm:flex-[0_0_50%] md:flex-[0_0_33%] lg:flex-[0_0_23.67%] pr-7">
                      <Image
                        src="/cpa/usp/us_logo3.png"
                        alt="MBE"
                        className=""
                        width={45}
                        height={58}
                      />
                    </div>
                    <div className="embla__slide h-full flex-[0_0_70%] min-w-0 sm:flex-[0_0_50%] md:flex-[0_0_33%] lg:flex-[0_0_23.67%] pr-7">
                      <Image
                        src="/cpa/usp/us_logo4.png"
                        alt="MBE"
                        className=""
                        width={122}
                        height={35}
                      />
                    </div>
                    <div className="embla__slide h-full flex-[0_0_70%] min-w-0 sm:flex-[0_0_50%] md:flex-[0_0_33%] lg:flex-[0_0_23.67%] pr-7">
                      <Image
                        src="/cpa/usp/us_logo5.png"
                        alt="MBE"
                        className=""
                        width={80}
                        height={55}
                      />
                    </div>
                    <div className="embla__slide h-full flex-[0_0_70%] min-w-0 sm:flex-[0_0_50%] md:flex-[0_0_33%] lg:flex-[0_0_23.67%] pr-7">
                      <Image
                        src="/cpa/usp/us_logo6.png"
                        alt="MBE"
                        className=""
                        width={105}
                        height={39}
                      />
                    </div>
                    <div className="embla__slide h-full flex-[0_0_70%] min-w-0 sm:flex-[0_0_50%] md:flex-[0_0_33%] lg:flex-[0_0_23.67%] pr-7">
                      <Image
                        src="/cpa/usp/us_logo7.png"
                        alt="MBE"
                        className=""
                        width={89}
                        height={56}
                      />
                    </div>
                    <div className="embla__slide h-full flex-[0_0_70%] min-w-0 sm:flex-[0_0_50%] md:flex-[0_0_33%] lg:flex-[0_0_23.67%] pr-7">
                      <Image
                        src="/cpa/usp/us_logo8.png"
                        alt="MBE"
                        className="mx-auto"
                        width={90}
                        height={20}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="w-full flex justify-end">
              <div
                className="w-[400px] p-4 border border-white rounded-2xl"
                style={{
                  background:
                    "linear-gradient(180deg, rgba(255, 255, 255, 0.30) 0%, rgba(51, 153, 255, 0.30) 100%)",
                  boxShadow: "0px 0px 14px 0px rgba(4, 84, 175, 0.29)",
                  backdropFilter: "blur(28px)",
                }}
              >
                <Image
                  src="https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa-visit/starGroup.webp"
                  alt="star group"
                  width={34}
                  height={38}
                  className="absolute top-1 left-0"
                />
                <GlobalForm
                  course="USP"
                  courseId={3}
                  formHeading={FormHeading.WORLD_FAVORITE_CMA_CPA_INSTRUCTOR}
                  formType="page"
                  isAStepperForm={true}
                  pageType="accounting page"
                  subCategory={FinanceAndAccountingSubcategory.USP}
                  submitButtonName="Start Your Journey"
                  successMessage={SuccessMessageType.ACCOUNTING}
                  verticalName={VerticalCategory.FINANCE_AND_ACCOUNTING}
                  showSVG={false}
                  darkBackground={false}
                />
              </div>
            </div>
          </div>
          <div className="lg_desktop">
            <Image
              src="/images/accounting/usp/desktop_banner.webp"
              alt="Special Offer"
              className="absolute top-0 bottom-0 right-0 z-10 h-full"
              width={760}
              height={580}
              priority
            />
          </div>
        </div>
        <div className="md_desktop">
          <Image
            src="/images/accounting/usp/desktop_banner.webp"
            alt="Special Offer"
            className="absolute top-0 bottom-0 right-0 md:block hidden xl:w-[680px] md:h-full z-10"
            width={740}
            height={590}
            priority
          />
        </div>
      </div>
    </>
  );
};

export default LpUspBanner;
